let navigateRef = null;

export function registerAppNavigate(navigate) {
  navigateRef = navigate;
}

export function unregisterAppNavigate() {
  navigateRef = null;
}

export function appNavigate(to, options) {
  if (navigateRef) {
    navigateRef(to, options);
    return;
  }
  window.location.assign(to);
}
